import React, { useState, useContext, useEffect } from 'react';
import { Slider } from '@mui/material';
import { MapContext } from '../MapContext';
import { colorsTab50 } from '../../common/Color';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import SGETypeToggleButtonItems from './SGETypeToggleButtonItems';
import './LayerPanel.css';

let instanceCount = 0;

const GeneControls = ({ layer, layerVisibility, layerExpanded, styles, layerProps, setLayerProps }) => {
  const { map } = useContext(MapContext);

  // Extract default values
  const defaultColor = colorsTab50[instanceCount % colorsTab50.length];
  const defaultRadius = 2.2; // Assuming 27 from the interpolation array

  const [radius, setRadius] = useState(styles?.circleRadius || defaultRadius);
  const [color, setColor] = useState(styles?.circleColor || defaultColor);
  const [isSGETypeExpand, setIsSGETypeExpand] = useState(false);
  const [typeItems, setTypeItems] = useState(styles?.sgeCheckbox ||
    [
      { type: "Gene", checked: false },
      { type: "GeneFull", checked: false },
      { type: "VelocytoAmbiguous", checked: false },
      { type: "VelocytoSpliced", checked: false },
      { type: "VelocytoUnspliced", checked: false }
    ]
  );

  useEffect(() => {
    !layerExpanded && setIsSGETypeExpand(false);
  }, [layerExpanded])

  useEffect(() => {
    if (map && map.current && layer) {
      map.current.setPaintProperty(layer.id, 'circle-color', defaultColor);
    }
  }, []);

  useEffect(() => {
    styles?.circleColor && setColor(styles.circleColor);
    styles?.circleRadius && setRadius(styles.circleRadius);
    styles?.sgeCheckbox && setTypeItems(styles.sgeCheckbox);
  }, [styles]);

  useEffect(() => {
    if (map && map.current && layer) {
      map.current.setPaintProperty(layer.id, 'circle-color', color);
      instanceCount++;
    }
  }, [color]);

  useEffect(() => {
    if (map && map.current && layer) {
      map.current.setPaintProperty(layer.id, 'circle-radius',
        [
          "interpolate",
          ["exponential", 2],
          ["zoom"],
          0, 0,
          21, ['*', 27, ["^", radius, 2]]
        ]
      );
    }
  }, [radius]);

  useEffect(() => {
    // verify if the gene color matches the color in layerProps
    if (layerProps.find(l => l.layerId === layer.id)) {
      const currentLayerProps = layerProps.find(l => l.layerId === layer.id);
      if (currentLayerProps.color !== color) {
        const updatedLayerProps = layerProps.map(props => {
          if (props.layerId === layer.id) {
            return { ...props, color: color };
          }
          return props;
        });
        setLayerProps(updatedLayerProps);
      }
    }
  }, [layerProps, color]);

  useEffect(() => {
    if (map && map.current && layer) {
      const filters = ['any']; // Start with 'any' to create an OR condition
      if (typeItems.find(item => item.type === "Gene")?.checked) filters.push(['>', ['to-number', ['get', 'Gene']], 0]);
      if (typeItems.find(item => item.type === "GeneFull")?.checked) filters.push(['>', ['to-number', ['get', 'GeneFull']], 0]);
      if (typeItems.find(item => item.type === "VelocytoAmbiguous")?.checked) filters.push(['>', ['to-number', ['get', 'VelocytoAmbiguous']], 0]);
      if (typeItems.find(item => item.type === "VelocytoSpliced")?.checked) filters.push(['>', ['to-number', ['get', 'VelocytoSpliced']], 0]);
      if (typeItems.find(item => item.type === "VelocytoUnspliced")?.checked) filters.push(['>', ['to-number', ['get', 'VelocytoUnspliced']], 0]);

      map.current.setFilter(layer.id, filters.length > 1 ? filters : null);
    }
  }, [typeItems]);

  const changeRadius = (event, newValue) => {
    setRadius(newValue);
  };

  const handleColorChange = (e) => {
    setColor(e.target.value);
  };

  const handleSGETypeExpand = () => {
    setIsSGETypeExpand(!isSGETypeExpand);
  }

  return (
    <div>
      <div className='layerPanelControl'>
        <span>SGE Type:</span>
        {isSGETypeExpand ? <ArrowDropUp onClick={handleSGETypeExpand} /> : <ArrowDropDown onClick={handleSGETypeExpand} />}

      </div>
      <div className='layerPanelControl'>
        {isSGETypeExpand ? <SGETypeToggleButtonItems typeItems={typeItems} setTypeItems={setTypeItems} layerVisibility={layerVisibility} /> : <></>}
      </div>
      <div className='layerPanelControl'>
        <span>Color:</span>
        <input
          type="color"
          value={color}
          onChange={handleColorChange}
          disabled={!layerVisibility}
        />
      </div>
      <div className='layerPanelControl'>
        <span>Radius:</span>
        <Slider
          value={radius}
          step={0.05}
          min={0}
          max={6}
          valueLabelDisplay="auto"
          onChange={changeRadius}
          disabled={!layerVisibility}
        />
      </div>
    </div>
  );
}

export default GeneControls;
